import { Component } from "excalibur";

export class AttractedComponent extends Component {
  constructor() {
    super();
  }
}
